import React, { useState } from 'react';
import Card from '../ui/Card';
import Input from '../ui/Input';
import Button from '../ui/Button';

const ManageSchools = () => {
    // Mock data for schools - in a real app, this would come from the backend
    const [schools, setSchools] = useState([
        { id: 1, name: 'Greenwood High', adminCount: 3, features: { students: true, teachers: true, courses: true, attendance: true, assessments: true, assignments: true } },
        { id: 2, name: 'Oakwood Academy', adminCount: 1, features: { students: true, teachers: true, courses: false, attendance: true, assessments: false, assignments: false } },
    ]);

    const allFeatures = ['students', 'teachers', 'courses', 'attendance', 'assessments', 'assignments'];

    const [newSchoolName, setNewSchoolName] = useState('');
    const [newAdminEmail, setNewAdminEmail] = useState('');

    const handleCreateSchool = (e) => {
        e.preventDefault();
        if (!newSchoolName) return;
        const newSchool = { id: Date.now(), name: newSchoolName, adminCount: 0, features: {} };
        setSchools([...schools, newSchool]);
        setNewSchoolName('');
    };

    const handleAddAdmin = (schoolId) => {
        alert(`Adding admin (${newAdminEmail}) to school ${schoolId}. This would be a backend call.`);
        setNewAdminEmail('');
    };

    const handleFeatureToggle = (schoolId, featureName) => {
        setSchools(schools.map(school => {
            if (school.id === schoolId) {
                return { ...school, features: { ...school.features, [featureName]: !school.features[featureName] } };
            }
            return school;
        }));
    };

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Manage Schools</h1>
            <div className="mb-8">
                <Card title="Create New School">
                    <form onSubmit={handleCreateSchool} className="flex items-end space-x-2">
                        <div className="flex-grow">
                            <label className="block text-sm font-medium text-gray-700">School Name</label>
                            <Input type="text" placeholder="e.g., Redwood High" value={newSchoolName} onChange={e => setNewSchoolName(e.target.value)} />
                        </div>
                        <Button type="submit">Create School</Button>
                    </form>
                </Card>
            </div>

            <div className="space-y-6">
                {schools.map(school => (
                    <Card key={school.id} title={school.name}>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Add Admin */}
                            <div>
                                <h4 className="font-semibold mb-2">Create School Admin</h4>
                                <div className="flex items-end space-x-2">
                                    <Input type="email" placeholder="new.admin@example.com" value={newAdminEmail} onChange={e => setNewAdminEmail(e.target.value)} />
                                    <button onClick={() => handleAddAdmin(school.id)} className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700">Add</button>
                                </div>
                            </div>

                            {/* Feature Configuration */}
                            <div className="md:col-span-2">
                                <h4 className="font-semibold mb-2">Configure Features</h4>
                                <div className="flex flex-wrap gap-4">
                                    {allFeatures.map(feature => (
                                        <label key={feature} className="flex items-center space-x-2 cursor-pointer">
                                            <input type="checkbox" checked={!!school.features[feature]} onChange={() => handleFeatureToggle(school.id, feature)} className="h-5 w-5 rounded text-blue-600 focus:ring-blue-500" />
                                            <span className="capitalize">{feature}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default ManageSchools;
